<template>
    <div class="col-sm-12 bg-lightest pt-4 pb-4">
        <div v-if="getIsDownloadingInvoiceList" class="text-center fs-large dark bold mb-4">
            Loading
        </div>

        <div v-else-if="!getInvoiceList.result || getInvoiceList.result.length == 0" class="text-center fs-large dark bold mb-4">
            You have no invoices.
        </div>

        <div v-else>
            <div class="col-sm-12 d-flex justify-content-end mb-4">
                <uib-pagination v-if="getInvoiceList.pageInfo && getInvoiceList.pageInfo.pageCount > 1" v-model="pagination" :total-items="getInvoiceList.pageInfo.totalItemCount" :items-per-page="20" :boundary-link-numbers="false" :max-size="7" @change="getReservationsPaginated"></uib-pagination>
            </div>

            <list :header="header" :body="body" :rows="getInvoiceList.result" :showNoDataMessage="false"></list>

            <div class="col-sm-12 d-flex justify-content-end mt-4">
                <uib-pagination v-if="getInvoiceList.pageInfo && getInvoiceList.pageInfo.pageCount > 1" v-model="pagination" :total-items="getInvoiceList.pageInfo.totalItemCount" :items-per-page="20" :boundary-link-numbers="false" :max-size="7" @change="getReservationsPaginated"></uib-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import List from '@/tools/list/baseList';
//mixins
import { invoicesMixin } from '@/mixins/invoices';

export default {
    data: function () {
        return {
            filters: null,
            pagination:{
                currentPage: 1,
            },
        }
    },
    created: function () {
        this.downloadInvoiceList();
    },
    mixins: [
        invoicesMixin
    ],
    computed: {
        ...mapGetters([
            'getInvoiceList',
            'getInvoicePageFilters',
            'getIsDownloadingInvoiceList'
        ]),
        header: function() {
            let vm = this
            return {
                selection: {
                    active: false,
                    event: function(event) {}
                },
                list: {
                    date: 'Date',
                    invoiceCode: 'Invoice',
                    type: 'Type',
                    client: 'Billed to',
                    linked: 'Linked to',
                    amount: 'Amount',
                },
            };
        },
        body: function() {
            let vm = this;

            return {
                selection: {
                    active: false,
                    event: function(event, row) {}
                },
                customRowEvent: function(row) {
                    vm.selectInvoice(row);
                },
                customCells: {
                    date: function(row) {
                        let invoice = vm.normalizeInvoice(row)

                        return vm.formatDateDots(invoice.date);
                    },
                    invoiceCode: function(row) {
                        let invoice = vm.normalizeInvoice(row);

                        return invoice.code;
                    },
                    type: function(row) {
                        let invoice = vm.normalizeInvoice(row);

                        let output = '<div class="d-flex"><span>'+invoice.type.label+'</span>';
                        if (invoice.bookingInvoiceLinkedId != null || !invoice.isActive) {
                            output += '<span class="lightest fs-smallest ml-2 px-3 py-1 bg-color-6 radius-stadium text-center font-weight-600" style="">Canceled</span>';
                        }
                        output += '</div>';

                        return output;
                    },
                    client: function(row) {
                        let invoice = vm.normalizeInvoice(row);

                        return invoice.name;
                    },
                    linked: function(row) {
                        let invoice = vm.normalizeInvoice(row);
                        let output = '<div class="d-flex"><div class="lightest fs-smallest px-2 py-1 bg-dark radius-stadium text-center font-weight-600" style="min-width: 120px;">';
                        output += invoice.bookingRelationsQuantity+' Booking'+( (invoice.bookingRelationsQuantity > 1)? 's':'');
                        output += '</div></div>';
                        
                        return output;
                    },
                    amount: function(row) {
                        let invoice = vm.normalizeInvoice(row);
                        return vm.formatPrice(invoice.value)+'€';
                    },

                },
                customClassCell: {
                    invoiceCode : 'pointer',
                },
            }
        },
    },
    methods: {
        ...mapActions([
            'downloadInvoiceList'
        ]),
        getReservationsPaginated: function() {
            this.getInvoicePageFilters.page = this.pagination.currentPage;
            this.downloadInvoiceList(this.pagination.currentPage);
        },
        selectInvoice: function(invoice) {
            this.$emit('selectInvoice', invoice);
        }
    },
    components:{
        List
    }
}

</script>

<style lang="scss" scoped="">
</style>



// WEBPACK FOOTER //
// InvoiceList.vue?071f1766